<script>
    import jQuery from "jquery";
    import {subscriberPurchase} from "./gppy-payments";
    import {slide} from "svelte/transition";

    let i18 = {
        "pl": {
            "Your purchase:": "Twój zakup:",
            "Buy now": "Kup teraz",
            "Transaction is processed by PayPal. Having the PayPal account is not required, you can pay with a debit/credit card.": "Po kliknięciu 'Kup teraz' przekierujemy Cię na stronę operatora płatności (PayPro&nbsp;SA/Przelewy24.pl). Po zakończeniu transakcji zostaniesz przekierowany tu z&nbsp;powrotem a&nbsp;Twój program będzie gotowy do pobrania.",
            "I need an invoice for this purchase": "Potrzebuję faktury za zakup"
        }
    }

    function t(message) {
        if (lang === "en") return message;
        if (lang === "pl") return i18['pl'][message] ? i18['pl'][message] : message;
    }

    let lang = document.documentElement.getAttribute("lang").toLowerCase() === "pl" ? "pl" : "en";

    export let product = null;
    export let productTable = null;

    let paymentProcessor = lang === "pl" ? "p24" : "paypal";

    let autoRenew = true;
    let invoiceNeeded = false;

    let purchaseInProgress = false;
    let step = "form";

    $: selectedProductPrice = productTable[product].currencyPrefix + productTable[product].price.toFixed(2) + productTable[product].currencyPostfix;
    $: selectedProductDescription =
        '<div class="productItem"><span class="productDesc">' + productTable[product].purchaseFormDesc + '</span> <span class="productPrice">(' + selectedProductPrice + ')</span></div>';

    export function showPurchaseForm() {
        jQuery('#purchaseForm').on('hidden.bs.modal', () => this.$destroy());
        jQuery('#purchaseForm').modal();
        window.addEventListener("pageshow", () => {purchaseInProgress = false});
    }


    function initPurchase() {
        purchaseInProgress = true;
        if (paymentProcessor === "paypal")
            step = "confirmation";
        subscriberPurchase(product, autoRenew && product === "PS12", invoiceNeeded);
    }

</script>


<div id="purchaseForm" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span>
                </button>
                <h4 class="modal-title">{t("Your purchase:")}</h4>
                <div class="form-group purchaseFormProductDesc">
                    {@html selectedProductDescription}
                </div>
            </div>
            <div class="modal-body">
                {#if step === "form"}
                    <div transition:slide|local>
                        <div class="purchaseArea">
                            {#if (paymentProcessor === "paypal" && product === "PS12" )}
                            <div class="form-group checkbox purchaseFormTerms" transition:slide|local>
                                <label id="label_autorenew">
                                    <input id="autorenew" type="checkbox" bind:checked={autoRenew}> Auto renew the access at just $12 / year<br/>You can cancel anytime
                                </label>
                            </div>
                            {/if}
                            {#if lang==='pl'}
                            <label id="label_invoiceNeeded">
                                <input id="invoiceNeeded" type="checkbox"
                                       bind:checked={invoiceNeeded}> {t("I need an invoice for this purchase")}
                            </label>
                            {/if}
                            <a role="button" class="btn btn-primary btn-purchase purchaseFormButton"
                               class:disabled={purchaseInProgress} on:click={initPurchase}><span
                                    class="total">{selectedProductPrice}</span>{t("Buy now")}</a>
                        </div>
                        <hr/>
                        <div class="form-group purchaseFormText help-block3">
                            <div class="help-block">{@html t("Transaction is processed by PayPal. Having the PayPal account is not required, you can pay with a debit/credit card.")}
                            </div>
                        </div>
                    </div>
                {/if}
               {#if paymentProcessor === "paypal"}
                    <div id="paypal-button-container"></div>
               {/if}
            </div>

        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->